export * as tasks from '@wix/auto_sdk_data_tasks/schemas';
export * as permissions from '@wix/auto_sdk_data_permissions/schemas';
export * as sharing from '@wix/auto_sdk_data_sharing/schemas';
export * as externalDatabaseConnections from '@wix/auto_sdk_data_external-database-connections/schemas';
export * as backups from '@wix/auto_sdk_data_backups/schemas';
export * as collections from '@wix/auto_sdk_data_collections/schemas';
export * as indexes from '@wix/auto_sdk_data_indexes/schemas';
export * as movementJobs from '@wix/auto_sdk_data_movement-jobs/schemas';
